import * as React from 'react';

import * as reactGlobalClick from '../../ts/reactGlobalClick';
import { IValuesCollection } from '../../ts/appTheme';
import { IDisplayValue } from '../../ts/Interfaces';
import { themeVars } from '../../../../pdc-platform/src/ts/themes/themeConstants';

export type ValidState = 'valid' | 'invalid' | 'none';

export interface ISuggestionValue extends IDisplayValue {
    type?: string;
}

export function ListSelectItem(props: {
    value: ISuggestionValue;
    reference: React.Ref<HTMLLIElement>;
    tabIndex: number;
    checked: boolean;
    singleSelectMode: boolean;
    validState: ValidState;
    theme: IValuesCollection;
    title?: React.JSX.Element;
    readOnly?: boolean;
    getIcon?(value: number): string;
    onChange(value: ISuggestionValue): void;
}) {
    const processOnChange = () => {
        reactGlobalClick.cancel();
        props.onChange(props.value);
    };

    const handleOnItemClick = (e) => {
        e.stopPropagation();
        e.preventDefault();

        if (props.readOnly !== true) {
            processOnChange();
        }
    };

    const { theme } = props;
    const itemStyle: React.CSSProperties = {};

    if (theme != null) {
        let background: string;

        if (props.checked) {
            const foregroundColor = theme[themeVars.itemSelector_SelectedItemForegroundColor];

            if (foregroundColor != null) {
                itemStyle.color = foregroundColor;
            }

            background = theme[themeVars.itemSelector_SelectedItemBackgroundColor];
        } else {
            switch (props.validState) {
                case 'valid':
                    background = theme[themeVars.itemSelector_ValidItemBackgroundColor];
                    break;

                case 'invalid':
                    background = theme[themeVars.itemSelector_InvalidItemBackgroundColor] || 'lightgray';
                    break;
            }
        }

        if (background != null) {
            itemStyle.background = background;
        }
    }

    let checkboxCell: React.JSX.Element;

    if (!props.singleSelectMode && props.checked != null) {
        const handleOnCheckboxClick = (e: React.MouseEvent<HTMLInputElement>) => {
            e.stopPropagation();
            // Not this! - e.preventDefault();
            processOnChange();
        };

        checkboxCell = (
            <td className="checkbox-cell">
                <input
                    className="check-box"
                    type="checkbox"
                    checked={props.checked}
                    onClick={handleOnCheckboxClick}
                    onChange={() => {}}
                />
            </td>
        );
    }

    let iconCell: React.JSX.Element;

    if (props.getIcon != null) {
        const iconType = props.getIcon(parseInt(props.value.value));

        iconCell = (
            <td className="icon-cell">
                <span className={'pr-1 glyphicon glyphicon-' + iconType}></span>
            </td>
        );
    }

    return (
        <li tabIndex={props.tabIndex} ref={props.reference}>
            <div
                className={
                    'list-group-item list-group-item-action' +
                    (props.checked ? ' active' : '') +
                    ' JEST-title-node-item'
                }
                style={itemStyle}
                onClick={handleOnItemClick}
            >
                <table className={'table-borderless w-100'}>
                    <tbody>
                        <tr>
                            {checkboxCell}
                            {iconCell}
                            <td className="title-cell">{props.title}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </li>
    );
}
